export default __webpack_public_path__ + "static/media/IconJoinOurTeam.35745131.png";